import ViewHistoryApi from "../model/ViewHistoryApi";

// let prevurl;
function ViewHistoryVM(ticketFilterData,currentPage,currentdata){
     let url = `/gettickets?page=${currentPage}&currentdata=${currentdata}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        // let prevurl;
        // if(currentdata==="normal"){
        //         prevurl=url
        // }
        // console.log("prevurl");
        // console.log(prevurl);
        // console.log("New url");
        console.log(url);
try{
    let response = ViewHistoryApi(url)
    return response
}
catch(error){
        throw error
}
}

export default ViewHistoryVM;